<script setup lang="ts">
import { UiButton, UiIcon, UiText } from "@shopexperts/shared";
import type { UiIconProps } from "@shopexperts/shared";

defineProps<{
    icon: UiIconProps["name"];
    title: string;
    description: string;
    actionLabel?: string;
}>();

defineEmits<{
    (e: "action"): void;
}>();
</script>

<template>
    <div class="py-16 text-center">
        <div class="mx-auto flex max-w-md flex-col items-center gap-3">
            <div class="flex h-12 w-12 items-center justify-center rounded-full bg-se-gray-100">
                <UiIcon :name="icon" class="h-6 w-6 text-se-gray-500" />
            </div>
            <UiText as="h6" variant="h6" class="font-semibold" :text="title" />
            <UiText as="p" variant="p-small" class="text-se-gray-600" :text="description" />
            <UiButton v-if="actionLabel" variant="primary" :label="actionLabel" @click="$emit('action')">
                <template #before_label>
                    <UiIcon name="plus-square" class="h-5 w-5" />
                </template>
            </UiButton>
        </div>
    </div>
</template>
